<div class="all">
  <div class="row">
    <div class="col-md-12">
      <img
        class="image"
        src="../../../../assets/images/delete@2x.png"
        (click)="imageClicked()"
      />
    </div>
  </div>
  <h3>Download {{(role ==='RM' || role ==='CM') ? 'Carrier' :  data.header}} CSV</h3>
  <div class="row buttons">
    <div class="col-md-6" *ngIf="region == 'India'">
      <mat-select
        class="dropdown"
        placeholder="Select Download Type"
        name="formname"
        #value
        [(ngModel)]="dropdownvalue"
        (selectionChange)="changed(dropdownvalue)"
      >
        <mat-option
          *ngFor="let val of options"
          [value]="val.viewValue"
          class="value"
        >
          {{ val.viewValue }}
        </mat-option>
      </mat-select>
    </div>
    <div   [ngClass]="region == 'Egypt' ? 'col-md-12 text-center' : 'col-md-6'">
      <div>
        <mat-form-field style="height: 40px;" >
          <mat-date-range-input [rangePicker]="picker">
            <input
              matStartDate
              placeholder="Start date"
              [ngModel]="startDates"
              (dateChange)="startDateChange($event)"
            />
            <input
              matEndDate
              placeholder="End date"
              [ngModel]="endDates"
              (dateChange)="endDateChange($event)"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker">
          </mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="col-md-12 download-all">
    <button
      *ngIf="region == 'Egypt'"
      type="button"
      mat-raised-button
      color="primary"
      class="create-button"
      (click)="downloadEgyptCSV()"
    >
      Download
    </button>
    <button
      *ngIf="region == 'India'"
      type="button"
      mat-raised-button
      color="primary"
      class="download-button"
      (click)="downloadCSV()"
    >
      Download
    </button>
  </div>
</div>